<template>
  <div style="width:100%">
    <el-row style="width:100%;margin-bottom:10px;" v-if="!draftDisable">
      <el-button class="AddUser" v-if="!draftDisable" @click="handleAddTM">添加金额信息</el-button>
    </el-row>
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      :header-cell-style="{background:'#F4F5F6'}"
    >
      <el-table-column show-overflow-tooltip align="center" prop="workInfo" label="名称">
        <template slot-scope="scope">
          <span v-if="!draftDisable" @click="tableClick(scope.row)">{{scope.row.name}}</span>
          <span v-else>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip align="center" prop="money" label="金额">
        <template slot-scope="scope">
          <span v-if="!draftDisable" @click="tableClick(scope.row)">{{scope.row.money}}</span>
          <span v-else>{{scope.row.money}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip align="center" prop="remark" label="备注">
        <template slot-scope="scope">
          <span v-if="!draftDisable" @click="tableClick(scope.row)">{{scope.row.remark}}</span>
          <span v-else>{{scope.row.remark}}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip align="center" prop="address" label="操作">
        <template slot-scope="scope">
          <span
            v-if="!draftDisable"
            @click.prevent="removeUser(scope.$index,scope.row)"
            style="cursor: pointer;color:#128BF1"
          >删除</span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible.sync="dialogVisibleAdd"
      width="50%"
      class="addUserDia"
      :before-close="handleCloseAdd"
      @close="handleClosedAdd"
      :append-to-body="true"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">添加金额信息</span>
      </div>
      <div class="diaContainer">
        <!-- 新增系统公告表单 -->
        <el-form ref="form" :model="AddMoneyForm" label-width="30%">
          <el-form-item label="名称">
            <!-- <el-input style="width:70%" v-model="AddMoneyForm.name"></el-input> -->
            <one-selected
              style="width:70%"
              :selectedId="AddMoneyForm.member_id"
              :selectedName="AddMoneyForm.name"
              @my-one-change="handleSearchPeopleChange"
            ></one-selected>
          </el-form-item>
          <el-form-item label="金额">
            <el-input style="width:70%" type="number" v-model="AddMoneyForm.money"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input style="width:70%" v-model="AddMoneyForm.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisibleAdd = false">取 消</el-button>
        <el-button type="primary" v-if="diaFormType=='add'" @click="handleAddUser">添 加</el-button>
        <el-button type="primary" v-if="diaFormType=='edit'" @click="handleEditUserForm">修 改</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Draggable from 'vuedraggable'
import OneSelected from './OneSelected.vue'
// import OneSelected from 'OneSelected'
import { Loading } from 'element-ui' //项目已经全局引入element的话可以不单独引入
export default {
  data() {
    return {
      tableData: [],
      dialogVisibleAdd: false,
      diaFormType: 'add',
      AddMoneyForm: {
        member_id: '',
        name: '',
        money: '',
        remark: '',
      },
      editTableIndex: '',
    }
  },
  components: {
    Draggable,
    OneSelected,
  },
  props: ['draftDisable', 'tableDataSettlement'],
  mounted() {},
  methods: {
    handleSearchPeopleChange(id, name) {
      this.AddMoneyForm.name = name
      this.AddMoneyForm.member_id = id
    },
    // 合同登记弹窗相关
    handleAddTM() {
      this.diaFormType = 'add'
      console.log('this.AddMoneyForm', this.AddMoneyForm)
      this.dialogVisibleAdd = true
    },
    removeUser(index, row) {
      this.tableData.splice(index, 1)
      this.$emit('my-jsontable-change', this.tableData)
      console.log(this.tableData)
    },
    tableClick(row, column, event) {
      this.diaFormType = 'edit'
      this.editTableIndex = this.tableData.findIndex(
        (item) => item.id == row.id
      )
      this.AddMoneyForm = row
      console.log('this.AddMoneyForm', this.AddMoneyForm)
      console.log('点击了哪一行', this.AddMoneyForm)
      this.dialogVisibleAdd = true
    },
    handleAddUser() {
      this.tableData.push({
        id: new Date().getTime(),
        member_id: this.AddMoneyForm.member_id,
        name: this.AddMoneyForm.name,
        money: this.AddMoneyForm.money,
        remark: this.AddMoneyForm.remark,
      })
      this.$emit('my-jsontable-change', this.tableData)
      this.dialogVisibleAdd = false
    },
    handleEditUserForm() {
      this.tableData[this.editTableIndex] = this.AddMoneyForm
      // 提交修改的那个
      console.log('提交修改this.AddMoneyForm', this.AddMoneyForm)
      this.$emit('my-jsontable-change', this.tableData)
      this.dialogVisibleAdd = false
    },
    handleCloseAdd() {
      this.dialogVisibleAdd = false
      this.$emit('my-jsontable-change', this.tableData)
    },
    handleClosedAdd() {
      this.AddMoneyForm = {
        member_id: '',
        name: '',
        money: '',
        remark: '',
      }
      this.diaFormType = 'add'
      this.editTableIndex = ''
    },
  },
  mounted() {},
  created() {
    if (this.tableDataSettlement) this.tableData = this.tableDataSettlement
  },
  watch: {
    tableDataSettlement(val, oldVal) {
      if (val) {
        this.tableData = val
      }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.checked-app-item {
  height: 30px !important;
  display: flex;
  align-items: center;
}
/deep/.el-table__empty-block {
  border-bottom: 1px solid #ebeef5;
}
</style>